import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as AppNativa } from '@capacitor/app';
import { esComandera } from '../store/deviceModeStore.js';

// El botón "atrás" de Android. Sin esto Android cerraba la app: no regresaba
// de Mesas o Cuentas al catálogo, y en la tablet que es la caja principal
// cerrar la app apagaba la caja interna con la que hablan las comanderas.
//
// En las pantallas de inicio no cierra: manda la app al fondo, como el botón
// de inicio, y todo sigue corriendo. En las demás regresa a la anterior.
// El inicio de una comandera es el plano de mesas: desde la orden de una mesa,
// "atrás" la regresa ahí. El de una caja es el catálogo.
const INICIOS_SIEMPRE = ['/login', '/aparato'];
const esInicio = (pathname) => INICIOS_SIEMPRE.includes(pathname)
  || (esComandera() ? pathname === '/tables' : pathname === '/' || pathname === '/open-session');

export default function BotonAtras() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android') return undefined;
    let quitar = null;
    AppNativa.addListener('backButton', () => {
      // Una hoja abierta se cierra primero (las que escuchan este aviso).
      const evento = new Event('gc-atras', { cancelable: true });
      if (!window.dispatchEvent(evento)) return;

      if (esInicio(pathname)) { AppNativa.minimizeApp(); return; }
      if (esComandera() && pathname === '/') { navigate('/tables'); return; }
      // react-router guarda la posición en el historial: si no hay a dónde
      // regresar (se abrió directo en esta pantalla), al inicio.
      if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
      else navigate(esComandera() ? '/tables' : '/', { replace: true });
    }).then((h) => { quitar = h; });
    return () => { quitar?.remove(); };
  }, [navigate, pathname]);

  return null;
}
